export const inputButtonText = "Прикріпити";
export const inputPlaceholderText = "Посилання";

export const requiredInputsNumber = 1;
export const inputsArray = Array(requiredInputsNumber).fill("");

export const initialData = [
  {
    id: "",
    link: "",
    order: -1,
  },
];

export const refetchMessage = {
  create: "Відео успішно додано",
  delete: "Відео успішно видалено",
};
